module.exports = __webpack_public_path__ + "img/contract.69bb695.svg";